import getRemBase from 'propel/getRemBase';

const backgroundVideoComponent = () => {
	const backgroundVideoBlocks = [];
	let backgroundVideos = [];

	const loadVideos = () => {
		backgroundVideos = document.querySelectorAll(
			'.acf-block__background-video-wrapper'
		);

		if (backgroundVideos.length) {
			backgroundVideos.forEach((backgroundVideo) => {
				if (backgroundVideo.hasAttribute('data-video-url')) {
					const videoURL =
						backgroundVideo.getAttribute('data-video-url');
					const videoLoopAttribute =
						backgroundVideo.getAttribute('data-video-loop');
					const hideMobileBackgroundVideo =
						backgroundVideo.getAttribute('data-hide-mobile');
					const parentBlock = backgroundVideo.closest('.acf-block');
					let videoLoop = true;
					let videoRendered = false;

					if (
						'false' === videoLoopAttribute ||
						'0' === videoLoopAttribute
					) {
						videoLoop = false;
					}

					if (parentBlock) {
						backgroundVideoBlocks.push(parentBlock);

						parentBlock.style.setProperty(
							'--blockHeight',
							`${parentBlock.offsetHeight / getRemBase()}rem`
						);
					}

					const renderVideo = () => {
						const wrapper = document.createElement('div');
						const video = document.createElement('video');

						wrapper.className = 'acf-block__background-video';
						video.src = videoURL;
						video.autoplay = true;
						video.playsInline = true;
						video.loop = videoLoop;
						video.muted = true;

						video.oncanplaythrough = (e) => {
							videoLoaded(e.target);
						};

						wrapper.appendChild(video);
						backgroundVideo.innerHTML = '';
						backgroundVideo.appendChild(wrapper);
						videoRendered = true;
					};

					if (hideMobileBackgroundVideo && window.innerWidth < 992) {
						window.addEventListener(
							'propel-viewport-changed-lg',
							() => {
								if (
									window.innerWidth >= 992 &&
									!videoRendered
								) {
									renderVideo();
								}
							}
						);
					} else {
						renderVideo();
					}
				}
			});
		}
	};

	const videoLoaded = (player) => {
		player.parentElement.classList.add('loaded');
	};

	const setBackgroundVideoSize = () => {
		if (backgroundVideoBlocks.length) {
			backgroundVideoBlocks.forEach((backgroundVideoBlock) => {
				backgroundVideoBlock.style.setProperty(
					'--blockHeight',
					`${backgroundVideoBlock.offsetHeight / getRemBase()}rem`
				);
			});
		}
	};

	loadVideos();

	window.addEventListener('load', setBackgroundVideoSize);
};

backgroundVideoComponent();

export default backgroundVideoComponent;
